import { GenericButtonProps, Generic } from './GenericButton';

export function DangerButton({ ...props }: GenericButtonProps) {
    const bgClass = props.disabled
        ? 'border-theme-outline bg-theme-950/40 text-theme-text/30'
        : 'border-red-400/60 bg-red-600/22 text-red-50 hover:border-red-300/80 hover:bg-red-600/32 focus-visible:ring-red-400/25';

    return <Generic {...props} className={bgClass + (props.className ? ' ' + props.className : '')} />;
}
